import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { ArcadeEmbed } from "./ArcadeEmbed"; // Add import
import { CreateCaseButton } from "./CreateCaseButton";

interface EmptyCasesListProps {
  disabled?: boolean;
}

export const EmptyCasesList: FC<EmptyCasesListProps> = ({ disabled }) => {
  return (
    <div className="flex flex-col justify-center items-center h-full space-y-6 mt-14">
      <p className="font-semibold ">
        <FormattedMessage
          id="casesList.emptyList"
          defaultMessage={"Create Your First Case And Upload Documents"}
        />
      </p>
      <CreateCaseButton disabled={disabled} />

      {/* Add margin to separate button from embed */}
      <div className="mt-8 w-full max-w-4xl">
        <ArcadeEmbed />
      </div>
    </div>
  );
};
